import { Box } from '@eneco/sparky';
import { styled } from '@eneco/sparky/stitches';

export const Relative = styled('section', {
  position: 'relative',
  picture: {},
});

export const RelativeZIndexBox = styled(Box, {
  position: 'relative',
  zIndex: 2,
});

export const Background = styled(Box, {
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: '-1',
});
